
///////////////////////////////////////////////////
// FUNCTIONS CALLED ON DOC READY 
///////////////////////////////////////////////////
$(document).ready(function($) { 
  initDownloads();
});


///////////////////////////////////////////////////
// INIT FUNCTIONS 
///////////////////////////////////////////////////

function initDownloads() {
  $.get('../datavis/data/strategies_full/', function(strategies) {
    let target = $('div#download');
    strategies.forEach(function(strategy) {
      let html = `${strategy.name}: <a href="./evidence/${strategy.id}">Download evidence</a>`
      let p = $('<p>', {
        html: html
      }).appendTo(target);
    });

  })
}